module.exports = __webpack_public_path__ + "img/aleo.918df338.png";